import translation from 'locales/translation';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Fade, Zoom } from '@material-ui/core';
import { CircleCheck } from 'components/Icons';

import { VotoPresencialPath } from 'library/Routes';

import useStyle from './style';

interface Props {
  cpf: string;
  idAssembleia: string;
}

const TIMEOUT_REDIRECT = 7000;

export default function VotacaoFinalizada({ cpf, idAssembleia }: Props) {
  const classes = useStyle();
  const history = useHistory();

  useEffect(() => {
    window.setTimeout(() => {
      history.push(VotoPresencialPath.replace(':idAssembleia', idAssembleia), {
        lastVote: cpf,
      });
    }, TIMEOUT_REDIRECT);
  }, [history, cpf, idAssembleia]);

  return (
    <div className={classes.root}>
      <Zoom in>
        <CircleCheck className={classes.icon} noFill />
      </Zoom>
      <Fade in>
        <p className={classes.title}>
          {translation.EfetivacaoVotacao.finalizadaTitle}
        </p>
      </Fade>
      <Fade in>
        <p className={classes.subtitle}>
          {translation.EfetivacaoVotacao.finalizadaSubtitle}
        </p>
      </Fade>
    </div>
  );
}
